var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _feBlend, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoforYouth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 261.7 134.4",
    style: {
      enableBackground: "new 0 0 261.7 134.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{opacity:0.3;fill:#FFFFFF;}\r\n\t.st2{fill:#EE9022;}\r\n\t.st3{fill:url(#SVGID_1_);}\r\n\t.st4{opacity:0.5;fill:url(#SVGID_2_);}\r\n\t.st5{opacity:0.5;fill:url(#SVGID_3_);}\r\n\t.st6{opacity:0.8;}\r\n\t.st7{filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st8{mask:url(#SVGID_4_);}\r\n\t.st9{fill:url(#SVGID_5_);}\r\n\t.st10{fill:url(#SVGID_6_);}\r\n\t.st11{opacity:0.75;fill:url(#SVGID_7_);}\r\n\t.st12{fill:url(#SVGID_8_);}\r\n\t.st13{opacity:0.75;fill:url(#SVGID_9_);}\r\n\t.st14{fill:url(#SVGID_10_);}\r\n\t.st15{fill:url(#SVGID_11_);}\r\n\t.st16{fill:url(#SVGID_12_);}\r\n\t.st17{fill:url(#SVGID_13_);}\r\n\t.st18{opacity:0.3;}\r\n\t.st19{fill:url(#SVGID_14_);}\r\n\t.st20{opacity:0;}\r\n\t.st21{fill:none;}\r\n\t.st22{fill:#2A2A2A;}\r\n\t.st23{fill:url(#SVGID_15_);}\r\n\t.st24{opacity:0.5;fill:url(#SVGID_16_);}\r\n\t.st25{opacity:0.5;fill:url(#SVGID_17_);}\r\n\t.st26{filter:url(#Adobe_OpacityMaskFilter_1_);}\r\n\t.st27{mask:url(#SVGID_18_);}\r\n\t.st28{fill:url(#SVGID_19_);}\r\n\t.st29{fill:url(#SVGID_20_);}\r\n\t.st30{opacity:0.75;fill:url(#SVGID_21_);}\r\n\t.st31{fill:url(#SVGID_22_);}\r\n\t.st32{opacity:0.75;fill:url(#SVGID_23_);}\r\n\t.st33{fill:url(#SVGID_24_);}\r\n\t.st34{fill:url(#SVGID_25_);}\r\n\t.st35{fill:url(#SVGID_26_);}\r\n\t.st36{fill:url(#SVGID_27_);}\r\n\t.st37{fill:url(#SVGID_28_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M92.4,84.9l-5.9-16.6L83,58.2l-4.6,9.6L67.9,89.3L57.5,67.8l-4.6-9.6l-3.6,10.1l-13.8,39.1h9.4l9.2-26.1 l13.7,26.1l13.7-26.1l6.7,18.8C88.4,94.7,89.8,89.5,92.4,84.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M14.6,78.7h13.2v8.9H14.6v10.9h17.8v9H5.7V58.3h26.6v8.9H14.6V78.7z M14.6,67.2v11.5V67.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M158.8,69.9c1.1,1.4,1.7,3,1.7,4.7c0,2-0.7,3.7-2.1,5.1c-1.4,1.4-3.1,2.1-5.1,2.1h-4.2v-6.4 c-1.4,0.6-2.7,1.2-4.1,1.8l-4.8,2.1v28.1h8.9V90.8h1.3l9.9,16.6h10.4l-10.8-18.1c1.7-0.8,3.3-1.8,4.8-3.3c3-2.9,4.8-7,4.8-11.4 c0-4.2-1.7-7.9-4.4-11c-0.3,0.4-0.6,0.8-0.9,1.2C162.5,66.8,160.7,68.4,158.8,69.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M197.5,82.4h27v0.1c0,7.2-2.3,13.5-7.1,18.3c-4.9,4.9-11.5,7.7-18.8,7.7c-7.2,0-13.6-2.7-18.3-7.6 c-4.7-4.8-7.6-11.1-7.6-18.3s2.9-13.5,7.6-18.3c4.7-4.9,11.2-7.6,18.3-7.6c4.3,0,8.3,1,11.7,2.8c3.7,1.9,6.9,4.5,9.2,7.9l-7.2,5.2 c-1.6-2.2-3.6-3.8-6-5.1c-2.4-1.3-5-1.9-7.7-1.9c-4.6,0-8.9,1.9-11.9,5c-3,3-5,7.3-5,11.9c0,4.8,1.9,8.9,5,12c3,3,7.3,5,11.9,5 c4.9,0,9.3-2,12.4-5.1c1-1,1.7-2,2.4-3l-15.9-0.2V82.4z M197.5,82.4v8.9V82.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M235.9,78.7h13.2v8.9h-13.2v10.9h17.8v9H227V58.3h26.6v8.9h-17.8V78.7z M235.9,67.2v11.5V67.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.6,78.7v-8c-3.9-3.8-6.9-7.9-8.8-12.3H5.7v49.1h26.6v-9H14.6V87.5h13.2v-7.2c-1-0.5-1.9-1.1-2.8-1.6H14.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.9,107.4l8-15.2c-5.8-0.1-11.4-0.6-16.8-1.5L67.9,107.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.5,107.4h9.4l6.4-18.2c-2.9-0.7-5.8-1.5-8.5-2.4L35.5,107.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.3,107.4h8.9V90.8h1.3l9.9,16.6h10.4l-9.9-16.5c-7.4-1.2-14.3-3-20.6-5.5V107.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.5,91.3l15.9,0.2c-0.7,1-1.5,2.1-2.4,3c-3.1,3.1-7.6,5.1-12.4,5.1c-4.6,0-8.9-1.9-11.9-5 c-0.8-0.8-1.5-1.7-2.1-2.6c-2,0.1-3.9,0.2-6,0.2c-1.4,0-2.7,0-4.1-0.1c1.3,3.3,3.3,6.3,5.8,8.8c4.7,4.9,11.1,7.6,18.3,7.6 c7.3,0,13.9-2.9,18.8-7.7c4.8-4.8,7.1-11.1,7.1-18.3v-0.1h-0.9c-7.6,3.8-16.5,6.6-26.1,8.2V91.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M227,80.6v26.8h26.6v-9h-17.8V87.5h13.2v-8.9h-13.2v-4C233.2,76.8,230.2,78.8,227,80.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.6,67.2v-8.9h-5c-1.2,3.1-3,6.1-5.2,8.9H253.6z"
  })), /*#__PURE__*/React.createElement("g", null, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M142.6,74.4c4.7-9,7.1-18.1,6.9-27.9c-0.2-11.2-5.7-19.2-14.9-25c-5-3.2-10.4-5.6-16.3-6.5 c-4.3-0.6-8.7-0.6-13-0.8c-0.5,0-1,0-1.8,0c5.7-3.9,11.5-6.7,18.1-7.6c10.6-1.5,19.3,2.8,27.5,8.7c2.2,1.6,4.5,3.2,6.9,4.4 c3.3,1.8,5.3,0.8,6.4-3c-2.1-0.4-4.1-0.9-5.2-2.5c2.2-0.8,4.4-1.4,6.4-2.4c2-1.1,3.8-2.6,6-4c-0.1,0.7-0.2,1.3-0.3,1.9 c1-0.8,1.9-1.6,2.8-2.3c2.3-1.5,3.9-0.7,4,2.1c0,0.4,0,0.8,0,1.2c-6.4,1.9-6.9,7.4-7.2,12.6c-0.3,6.5,0,13.1-0.1,19.7 c-0.1,7.4-2.8,13.9-7.5,19.7C156.5,68.5,149.7,71.3,142.6,74.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.0945,
    y1: 66.1046,
    x2: 150.1294,
    y2: -3.2844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3DE24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    style: {
      stopColor: "#E9A824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F15B29"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M142.6,74.4c4.7-9,7.1-18.1,6.9-27.9c-0.2-11.2-5.7-19.2-14.9-25c-5-3.2-10.4-5.6-16.3-6.5 c-4.3-0.6-8.7-0.6-13-0.8c-0.5,0-1,0-1.8,0c5.7-3.9,11.5-6.7,18.1-7.6c10.6-1.5,19.3,2.8,27.5,8.7c2.2,1.6,4.5,3.2,6.9,4.4 c3.3,1.8,5.3,0.8,6.4-3c-2.1-0.4-4.1-0.9-5.2-2.5c2.2-0.8,4.4-1.4,6.4-2.4c2-1.1,3.8-2.6,6-4c-0.1,0.7-0.2,1.3-0.3,1.9 c1-0.8,1.9-1.6,2.8-2.3c2.3-1.5,3.9-0.7,4,2.1c0,0.4,0,0.8,0,1.2c-6.4,1.9-6.9,7.4-7.2,12.6c-0.3,6.5,0,13.1-0.1,19.7 c-0.1,7.4-2.8,13.9-7.5,19.7C156.5,68.5,149.7,71.3,142.6,74.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 133.6743,
    y1: 68.2621,
    x2: 133.6743,
    y2: 9.271
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1298,
    style: {
      stopColor: "#F6EB16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1993,
    style: {
      stopColor: "#F6DF1A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3346,
    style: {
      stopColor: "#F6C41F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    style: {
      stopColor: "#F79721"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5336,
    style: {
      stopColor: "#F79421"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9779,
    style: {
      stopColor: "#F15B27"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M145.4,68.3c2.7-7.2,4-14.4,3.9-21.8c-0.2-11.5-6.2-20.1-17.1-26.4c-6.1-3.6-11.3-4.6-17-5.4 c-1.4-0.2-10.4-0.4-11.7-0.5c2.5-1,12.8-4.3,15.3-4.6c1.3-0.2,2.6-0.3,3.8-0.3c8.5,0,15.6,4.3,21.5,8.4c2.5,1.8,4.7,3.3,7.2,4.6 c1.5,0.8,2.9,1.2,4.2,1.2c2.2,0,5.1-1.1,6.6-6.1l0.3-1l1.5-1.2c-1,2.7-1.1,5.6-1.2,7.8c-0.2,4.1-0.2,8.3-0.1,12.4c0,2.4,0,5,0,7.4 c-0.1,6.5-2.3,12.3-6.8,17.8C152.9,64,149.4,66.3,145.4,68.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 133.6743,
    y1: 68.2621,
    x2: 133.6743,
    y2: 9.271
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1298,
    style: {
      stopColor: "#F6EB16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1993,
    style: {
      stopColor: "#F6DF1A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3346,
    style: {
      stopColor: "#F6C41F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    style: {
      stopColor: "#F79721"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5336,
    style: {
      stopColor: "#F79421"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9779,
    style: {
      stopColor: "#F15B27"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M145.4,68.3c2.7-7.2,4-14.4,3.9-21.8c-0.2-11.5-6.2-20.1-17.1-26.4c-6.1-3.6-11.3-4.6-17-5.4 c-1.4-0.2-10.4-0.4-11.7-0.5c2.5-1,12.8-4.3,15.3-4.6c1.3-0.2,2.6-0.3,3.8-0.3c8.5,0,15.6,4.3,21.5,8.4c2.5,1.8,4.7,3.3,7.2,4.6 c1.5,0.8,2.9,1.2,4.2,1.2c2.2,0,5.1-1.1,6.6-6.1l0.3-1l1.5-1.2c-1,2.7-1.1,5.6-1.2,7.8c-0.2,4.1-0.2,8.3-0.1,12.4c0,2.4,0,5,0,7.4 c-0.1,6.5-2.3,12.3-6.8,17.8C152.9,64,149.4,66.3,145.4,68.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 142.6,
    y: 23.2,
    width: 26.4,
    height: 51.2
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 142.6,
    y: 23.2,
    width: 26.4,
    height: 51.2,
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 128,
    height: 231,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBLAEsAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAALzAAAFVwAACB7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAOkAhQMBIgACEQEDEQH/ xACfAAEBAQEAAwEBAAAAAAAAAAAABgUEAgMIAQcBAQEAAAAAAAAAAAAAAAAAAAABEAABAwIFAwIG AgMAAAAAAAABAgMEAAUwETVGByASFhATcCExIjIzQBQjFQYRAAECAgcGBQQBBQAAAAAAAAEAAgME EBEhs3TEhTAxQdKTNSBRcRIiQGETFIGx0UJSFRIBAAAAAAAAAAAAAAAAAAAAcP/aAAwDAQACEQMR AAAA9MrQR5oM8aDPGgzxoM8aDPGgzxoM8VjjGhH2EeAAAAAAAUANCPsI8AAAAAH6eXh18pvg0I+w jwAAAAB7/RsDIop43gaEfYR4AAAAB7KfIozhmK2TN0GhH2EeAAAAD3FDs+jvrKj7ONjcBoR9hHgA AADWya02ejz/AGzFirCNl3waEfYR4AAAB13GHW17ufuzSaltrFigBoR9hHgAADt5rE0dv09lejC1 ZQm+YigBoR9hHgADyU5+1vjrV4+r35Rww+1LR+AoAaEfYR4A9vXUnHU+WpTz/eKPCc6oquT0EAUA NCPsI8e706pSb2frV2efLynTjc8oeeOQABQA0I+wjxTz1QbPTkctbONi5cdPKAAAFADQj7CPOrRx fw7+LxAAAAAFADQj/oAfP76AHz++gB8/voAfP76AHz++gB8/voAfP76AH8ff2Af/2gAIAQIAAQUA +A//2gAIAQMAAQUA+A//2gAIAQEAAQUA5Eulzh3vyC/V5Bfq8gv1eQX6vIL9XkF+ryC/V5Bfq8gv 1eQX6vIL9XkF+ryC/V5Bfq8gv1f7i7+Fcna9j7C5O17H2Fydr2KPTYXJ2vYqU/I/XYXJ2vYgGZDW TZ+uwuTtexIjRcceZ7WlflsLk7XsS2RskSUf4l/nsLk7XsOO2XXYzISiUn7HPz2Fydr2HZmO5bbe SZafsd/ZsLk7XsO0R+xlKMkzU/a9+3YXJ2vYURouyILOSSjJM4fa/wDu2Fydr2FYo/e5FayStOSb h8kunud2Fydr2D9askX22WG8kvDJN2WEtk5nYXJ2vYNtjl+Tb4+SUIyTJOQvz3axWwuTtewbDA7G 4jOQIyTNXkP+ge7lVsLk7XsC1wzJkW+L2hlvtDyshcXshcH/AHpVbC5O17rZZW+5Z7alluLH7QR2 iW7kL3NDbROZrYXJ2vdSEKcVZbP7QhxO0IbCQ+sJFwkAC7yy/I9Nhcna90oQtxVms3t1ChBIaaCQ 4oJE2QAL3cfbQSSfTYXJ2vdEeM9IXabKhqoUIJDTISFkJEuQALpOShMySqS967C5O171g2pySbfa 220xIYTTTQSFKCRJkACfNAF3uBkOdGwuTte9IjReft8YBMVgANJACnAkSJQAmzwBdrsp1XTsLk7X vSxMdzsJAAZUAC+AH5gAm3JKRcrwt89WwuTteofOrQwG2mFhI/sgB6cALheW2hMuD0pXXsLk7Xqi t+49GIQn+0EiTdW2hLvbrlLWpasDYXJ2vVDIQo3JtCX7q8ulLUs4WwuTteruNZ4uwuTtex9hfwf/ 2gAIAQICBj8AB//aAAgBAwIGPwAH/9oACAEBAQY/AIEKTnI8vDMqxxZCivhtLjEiiuphFti7nN9e JzLuc314nMu5zfXicy7nN9eJzLuc314nMu5zfXicy7nN9eJzLuc314nMu5zfXicy7nN9eJzLuc31 4nMu5zfXicy7nN9eJzLuc314nMu5zfXicy/a/emP2P8Ap/j/ADfmf+T8f6/u9nv91ftrtqUvhGXk b6DVsspfCMvI30GrZZS+EZeRvoNWyyl8Iy8jbaujVsspfCMvI21qVaK1bLKXwjLyNtR5CgrVsspf CMvI2195FpTvRH1WrZZS+EZeRto1g4lADgj6J3qtWyyl8Iy8jbQxCN1goKd6rVsspfCMvI20ZZaR Wf5oKf6latllL4Rl5G2bGcK7ULKCn+pWrZZS+EZeRtmYpG6wIUFPPmStWyyl8Iy8jbNgIt3n+aXn yBRPmtWyyl8Iy8jbJoq+LbShZQU/72UatllL4Rl5G2Qc4fJ1pQoKbDHE1mjVsspfCMvI2xFY+DbT 6oWUlPdwFgo1bLKXwjLyNsBDYKyU1oHqfuhZQU412mweqrPGjVsspfCMvI3jDGCtx3BB7xW928oW UFG1FgPxZ/WnVsspfCMvI3iDGCtx3BB7xXEO8oWUm1EA/N1jQiTvNOrZZS+EZeRvD7Iba/M8Ag4i t53uQspNqcSagEYh3f4j7eDVsspfCMvI3gDn2M8uJQa1tQQspNqNqMJp+A3nzPh1bLKXwjLyNSxn Am1AVIWUm1G1GFCNm5zvFq2WUvhGXkakxCN1gQp3okuqqTocI1N3F39vHq2WUvhGXkaipNHHeUFv W9Gt1vADejWamcBsNWyyl8Iy8jUNHCtBb0S51SLYVg/2KLnGsnidjq2WUvhGXkaj3Fb7UQz4jzVb iSfvs9Wyyl8Iy8jfQatllL4Rl5G+g1bLfRf/2Q==",
    transform: "matrix(0.24 0 0 0.24 140.3808 21.135)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.6082,
    y1: 48.7999,
    x2: 168.959,
    y2: 48.7999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6EB16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    style: {
      stopColor: "#F6E817"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#F6E219"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5936,
    style: {
      stopColor: "#F6D91B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7177,
    style: {
      stopColor: "#F6CB1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8311,
    style: {
      stopColor: "#F6BA20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9352,
    style: {
      stopColor: "#F6A421"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79421"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M169,23.2c0,2.1-4.4,12.9-5.1,14.9c-2.4,7-3.2,12-7.9,17.7c-2.5,3-5.4,5.2-8.6,7.1 c-1.1,3.9-2.7,7.7-4.7,11.5c7.1-3.1,13.9-5.9,18.8-11.9c4.7-5.8,7.4-12.2,7.5-19.7C168.9,36.3,168.6,29.7,169,23.2L169,23.2z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.1644,
    y1: 128.4268,
    x2: 116.1644,
    y2: 61.5573
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5EB12"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7318,
    style: {
      stopColor: "#E9A824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F15B29"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M140.4,61.6c-3.6,3.8-8,6.2-12.4,8.9c-5.1,3.1-10.3,6-15,9.7c-11,8.6-12.1,22.5-7.1,32.6 c3,6,8.4,8.9,14.7,10.3c6.3,1.4,12.6,1.4,18.9,0.4c0.1,0.2,0.1,0.3,0.2,0.5c-3,1-5.9,2.3-9,3.1c-8.2,2.2-16.3,1.9-24-2.1 c-16.5-8.6-19.9-31.1-6.7-44.2c4.6-4.6,10.1-7.5,16.2-9.5c5.3-1.8,10.7-3.4,16-5.4C135.1,64.7,137.6,63,140.4,61.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.445,
    y1: 113.733,
    x2: 128.3993,
    y2: 67.0468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5EB12"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5307,
    style: {
      stopColor: "#E9A824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F15B29"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M120.1,72.3c-5.4,1.8-10.3,4.4-14.3,8.4c-11.6,11.6-8.6,31.4,5.9,38.9c0.6,0.3,1.1,0.6,1.7,0.8 c-3.1-1.7-5.7-4.2-7.4-7.7c-5-10.1-3.9-24,7.1-32.6c4.7-3.6,9.9-6.6,15-9.7c1-0.6,2-1.2,3-1.8C127.4,69.9,123.7,71,120.1,72.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.1988,
    y1: 116.0523,
    x2: 125.1988,
    y2: 57.6004
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5EB12"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    style: {
      stopColor: "#E9A824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F15B29"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M134.2,114.8c-6.4,1.7-12.7,1.7-18.8-0.7c-8-3.1-11.5-9.8-10.1-18.3c1.2-6.9,5.2-11.9,10.6-15.7 c4.3-3,8.9-5.6,13.4-8.3c4.8-2.9,9.7-5.6,13.3-10c0.9-1.2,1.7-2.5,2.8-4.2c-1.5,6.8-3.3,12.9-6.8,18.1c-5.3,2.1-10.4,3.9-15.4,6.1 c-5.5,2.4-9.6,6.3-10.7,12.5c-1.1,6.2,2.3,12.7,8,16C124.8,112.8,129.3,114.2,134.2,114.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.3123,
    y1: 109.7607,
    x2: 138.18,
    y2: 75.3488
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5EB12"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5307,
    style: {
      stopColor: "#E9A824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F15B29"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M123.2,81.8c5-2.2,10.1-4,15.4-6.1c0,0,0-0.1,0-0.1c-1-0.1-2-0.1-3-0.1c-14,0-25.3,8.8-25.3,19.7 c0,10.4,10.4,19,23.5,19.7c0.1,0,0.2,0,0.3-0.1c-4.8-0.7-9.4-2.1-13.6-4.5c-5.7-3.4-9.1-9.8-8-16 C113.6,88.1,117.7,84.2,123.2,81.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.7054,
    y1: 30.9348,
    x2: 146.7604,
    y2: 30.9348
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5EB12"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    style: {
      stopColor: "#E9A824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F15B29"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M91.2,14.1c2,1.5,3.9,3.1,6,4.5c5.5,3.6,11.6,5.3,18.1,5.9c5.4,0.5,10.9,1.1,16.3,1.3 c4.6,0.1,7.7,2.3,10.3,5.8c3.4,4.6,5.6,9.5,4.7,15.4c0,0.2-0.1,0.5-0.2,0.8c-7.6-4.3-16-5.5-24.4-6.7 c-11.7-1.7-21.5-6.7-27.4-17.5c-1.6-2.9-2.5-6.1-3.8-9.2C90.9,14.2,91,14.2,91.2,14.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.767,
    y1: 31.1018,
    x2: 146.7572,
    y2: 31.1018
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3DE24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4804,
    style: {
      stopColor: "#E9A824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8883,
    style: {
      stopColor: "#F15B29"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M120.8,34.9c-12.4-1.8-22.8-7.1-29.1-18.5c-0.3-0.6-0.7-1.3-1-1.9c1.2,3,2.2,6.2,3.7,9.1 c5.9,10.8,15.7,15.8,27.4,17.5c8.4,1.2,16.8,2.4,24.4,6.7c0.1-0.3,0.2-0.5,0.2-0.8c0.3-1.7,0.2-3.4,0-4.9 C138.5,37.5,129.7,36.2,120.8,34.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.4311,
    y1: 35.5298,
    x2: 139.2149,
    y2: 20.6857
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3DE24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6648,
    style: {
      stopColor: "#E9A824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F15B29"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M144.3,35.5c-8.1-4.1-16.9-5.3-25.8-6.6c-11.3-1.6-20.9-5.9-27.7-14.6c-0.1,0-0.1,0-0.2,0.1 c0,0.1,0,0.1,0.1,0.2c0.3,0.7,0.6,1.3,1,1.9c6.3,11.4,16.6,16.7,29.1,18.5c8.9,1.3,17.7,2.6,25.8,7.1 C146.3,39.7,145.5,37.6,144.3,35.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.7214,
    y1: 33.2046,
    x2: 135.4977,
    y2: 16.5218
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3DE24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8324,
    style: {
      stopColor: "#E9A824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F15B29"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M118.6,28.9c8.8,1.3,17.6,2.5,25.8,6.6c-0.7-1.3-1.6-2.6-2.5-3.9c-2.6-3.5-5.7-5.6-10.3-5.8 c-5.4-0.2-10.9-0.7-16.3-1.3c-6.4-0.6-12.6-2.3-18.1-5.9c-2.1-1.4-4-3-6-4.5c-0.1,0-0.2,0.1-0.3,0.1 C97.7,22.9,107.3,27.2,118.6,28.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.7054,
    y1: 30.9348,
    x2: 146.7604,
    y2: 30.9348
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5EB12"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    style: {
      stopColor: "#E9A824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F15B29"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M91.1,14.4c0.6,0.4,1.2,0.9,1.8,1.4c1.3,1,2.7,2.1,4.2,3.1c5,3.3,11,5.3,18.2,6l1.6,0.2 c4.8,0.5,9.8,1,14.7,1.1c4.1,0.1,7.3,1.9,10.1,5.7c3.9,5.3,5.4,10.1,4.7,15.2c0,0.1-0.1,0.3-0.1,0.4c-7.5-4.2-15.9-5.4-24-6.6 l-0.2,0c-12.9-1.9-21.9-7.6-27.2-17.4c-1.1-2-1.9-4.1-2.7-6.2c-0.3-0.9-0.7-1.8-1-2.7L91.1,14.4L91.1,14.4 M91.2,14.1 c-0.2,0.1-0.3,0.1-0.5,0.2c1.2,3.1,2.2,6.3,3.8,9.2c5.9,10.8,15.7,15.8,27.4,17.5c8.4,1.2,16.8,2.4,24.4,6.7 c0.1-0.3,0.2-0.5,0.2-0.8c0.9-5.9-1.3-10.8-4.7-15.4c-2.6-3.5-5.7-5.6-10.3-5.8c-5.4-0.2-10.9-0.7-16.3-1.3 c-6.4-0.6-12.6-2.3-18.1-5.9C95.1,17.3,93.2,15.6,91.2,14.1L91.2,14.1z"
  }))))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.5,91.7c-1.3,0.1-2.7,0.2-4.1,0.3l2.9,8.1C88.4,97.2,88.8,94.4,89.5,91.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M179.7,9.2c-0.2-4.3-3-6.2-5.6-6.2c-0.1,0-0.1,0-0.2,0l0.5-3l-6.9,4.7c-0.7,0.5-1.3,0.9-2,1.4 c-1.3,0.9-2.4,1.8-3.6,2.4c-1.1,0.6-2.5,1-3.9,1.5c-0.7,0.2-1.4,0.5-2.1,0.7l-4.1,1.5l0.6,1c-0.4-0.3-0.9-0.6-1.3-0.9 c-6.3-4.5-14.9-9.7-25.4-9.7c-1.6,0-3.2,0.1-4.8,0.3c-6.5,0.9-12.8,3.6-19.6,8.2l-4.4,3c-0.6-0.5-1.2-0.9-1.9-1.4 c-0.6-0.5-1.3-1-1.9-1.5l-1.6-1.2L89.5,11L86,12.3l1.4,3.5c0.3,0.9,0.7,1.7,1,2.7c0.4,0.9,0.7,1.9,1.1,2.9l0,0.1 c0.1,0.3,0.3,0.6,0.4,1l0.1,0.3c0.1,0.3,0.3,0.6,0.4,0.9c0,0,0.1,0.2,0.2,0.3c0.2,0.4,0.4,0.9,0.6,1.2c6,10.9,15.8,17.2,30.1,19.3 l0.2,0c4.2,0.6,8.1,1.2,12,2.1c1,0.2,2,0.5,2.9,0.8c3,0.9,5.7,2,8.1,3.4l1,0.6c-0.1,1.8-0.3,3.5-0.6,5.2l-2.5-1.1 c-0.4,0.6-0.7,1.1-1.1,1.6c-0.6,0.9-1.1,1.7-1.6,2.3c0,0-0.1,0.1-0.1,0.1l-0.9-1.3c-0.9,0.5-1.8,1-2.7,1.4c-1.8,1-3.4,1.9-5.1,2.6 c-4,1.5-8.2,2.9-12.2,4.2c-1.2,0.4-2.4,0.8-3.6,1.2c-7.3,2.4-13.1,5.8-17.7,10.4c-7.1,7.1-10.3,16.9-8.8,27 c1.5,10,7.5,18.3,16.3,23c4.9,2.6,10.3,3.9,15.9,3.9c3.4,0,7.1-0.5,10.8-1.5c2.3-0.6,4.4-1.4,6.5-2.2c0.9-0.3,1.8-0.7,2.7-1 l3.3-1.2l-2.1-6.7l-3,0.4c-2.8,0.4-5.5,0.6-8.1,0.6c-3.3,0-6.5-0.3-9.5-1c-0.8-0.2-1.6-0.4-2.3-0.6c2.1,0.4,4.3,0.7,6.4,0.7 c3,0,6.1-0.4,9.3-1.3c0,0,0.2-0.1,0.3-0.1l-0.4-7c-1-0.1-2-0.3-3-0.5c-2.4-0.5-4.5-1.2-6.4-2.1c-1-0.4-1.9-0.9-2.9-1.5 c-0.3-0.2-0.6-0.3-0.8-0.5c-0.5-0.4-1-0.8-1.5-1.2c-0.2-0.2-0.5-0.4-0.7-0.7c-0.9-0.9-1.6-2-2.2-3.1c-1.1-2.2-1.5-4.6-1.1-6.8 c0.1-0.6,0.2-1.2,0.4-1.7c0.3-0.8,0.6-1.5,1-2.2c0.3-0.5,0.6-0.9,0.9-1.3c1.4-1.8,3.6-3.4,6.3-4.6c3.4-1.5,6.8-2.8,10.4-4.2 c0.1,0,0.2-0.1,0.4-0.1l-0.4,0.9l10.1-4.4c6.8-3,13.9-6.1,19.1-12.4c5.4-6.6,8.2-14,8.3-21.9c0-2.5,0-5.1,0-7.6 c0-3.9-0.1-8,0.1-12c0.3-6,1.1-8.3,4.7-9.4l2.5-0.8v-2.7l0-0.3C179.8,9.9,179.8,9.6,179.7,9.2z M103.3,17.7c0.6,0,1.9,0.1,4.2,0.2 c2.1,0.1,4.5,0.1,6,0.2c0.5,0,0.9,0.1,1.4,0.1c4.5,0.6,8.1,1.3,11.9,3.1c0.6,0.3,1.2,0.6,1.9,0.9c-3.5-0.2-6.9-0.5-11-0.9l-2-0.2 c-4.9-0.5-9-1.5-12.7-3.3c0,0-0.1,0-0.1-0.1L103.3,17.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M151.7,123.8l5.1-7.8h3.1l-7.3,10.7l-1.3,6.4h-2.8l1.4-6.5L147,116h2.8L151.7,123.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M181.1,125c0,1.6-0.3,3-0.9,4.3s-1.4,2.3-2.3,3s-2.1,1-3.4,1c-1.5,0-2.7-0.4-3.6-1.3s-1.3-2.1-1.3-3.7 c0-1.6,0.3-3,0.8-4.3s1.3-2.3,2.3-3s2.2-1.1,3.5-1.1c1.5,0,2.7,0.5,3.6,1.4S181.1,123.4,181.1,125z M178.3,124.9 c0-0.8-0.2-1.5-0.6-2s-0.9-0.7-1.6-0.7c-0.7,0-1.4,0.3-2,0.8s-1,1.3-1.3,2.3s-0.5,2-0.5,3.1c0,0.9,0.2,1.5,0.6,2s1,0.7,1.7,0.7 c0.7,0,1.3-0.3,1.9-0.8s1-1.3,1.3-2.2C178.2,127.1,178.3,126,178.3,124.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M198.9,120.1l-1.5,7.1c-0.2,1.1-0.4,1.9-0.4,2.3c0,1,0.5,1.6,1.5,1.6c0.6,0,1.1-0.2,1.7-0.7s1-1.1,1.5-1.9 c0.4-0.8,0.8-1.8,1-2.9l1.2-5.5h2.7l-2.7,13h-2.2l0.2-2.4h-0.1c-0.6,0.9-1.3,1.6-2,2s-1.4,0.6-2.2,0.6c-1,0-1.9-0.3-2.4-0.9 s-0.9-1.4-0.9-2.6c0-0.5,0-1,0.1-1.5c0.1-0.5,0.2-1,0.3-1.4l1.4-6.8H198.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M223.3,131.1c0.5,0,1.1-0.1,1.8-0.4v2.1c-0.3,0.1-0.6,0.2-1.1,0.4s-0.9,0.2-1.4,0.2c-2.1,0-3.2-1-3.2-2.9 c0-0.4,0.1-1,0.2-1.5l1.4-6.7h-1.9l0.2-1.3l2.2-1l1.5-2.7h1.7l-0.6,2.9h3.3l-0.5,2.1h-3.2l-1.4,6.7c-0.1,0.4-0.2,0.8-0.2,1.1 c0,0.3,0.1,0.6,0.3,0.8S222.9,131.1,223.3,131.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M245.8,133.1l1.7-7.9c0.1-0.7,0.2-1.2,0.2-1.5c0-1.1-0.5-1.6-1.5-1.6c-0.9,0-1.7,0.5-2.5,1.5s-1.3,2.3-1.7,4 l-1.1,5.5h-2.8l3.9-18.2h2.8l-0.7,3.1c-0.2,1-0.5,2.1-0.9,3.4l-0.2,0.9h0.1c0.7-0.8,1.3-1.4,2-1.8s1.4-0.6,2.1-0.6 c1.1,0,1.9,0.3,2.4,0.9s0.8,1.5,0.8,2.6c0,0.6-0.1,1.3-0.3,2l-1.6,7.7H245.8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoforYouth);
export default __webpack_public_path__ + "static/media/logo for Youth.0dbf51ff.svg";
export { ForwardRef as ReactComponent };